$( '.block-imagesBlock' ).each( function() {
	const $this = $( this );

	const $imageCarousel = $( '.image-carousel', $this );
	const $swiperContainer = $imageCarousel.parents( '.swiper-container' );
	const $galleryThumbs = $( '.gallery-thumbs', $this );

	if ( !$imageCarousel.length ) {
		return;
	}

	const swiper = new Swiper( $imageCarousel[ 0 ], {
		pagination: {
			el: $swiperContainer.find( '.swiper-pagination' )[ 0 ],
		},
		navigation: {
			nextEl: $imageCarousel.parents( '.swiper-container' ).find( '.carousel-next' )[ 0 ],
			prevEl: $imageCarousel.parents( '.swiper-container' ).find( '.carousel-previous' )[ 0 ],
		},
		grabCursor: true,
		slidesPerView: 1,
		spaceBetween: 0,
		loop: false,
	} );

	// swiper.on( 'slideChange slideChangeTransitionEnd', function() {
	// 	animateInViewport();
	//
	// 	const currentSlide = swiper.slides[ swiper.activeIndex ];
	// 	const imageUrl = currentSlide.getAttribute( 'data-image-url' );
	// 	$this.find( '.zoom-button' ).attr( 'href', imageUrl );
	// } );

	if ( $galleryThumbs.length ) {
		const thumbs = new Swiper( $galleryThumbs[ 0 ], {
			slidesPerView: 'auto',
			spaceBetween: 24,
			centeredSlides: true,
			loop: false,
			slideToClickedSlide: true,
		} );

		swiper.controller.control = thumbs;
		thumbs.controller.control = swiper;
	}
} );
